<template functional>
    <span
        :class="['variants grow shrink-0', props.wrapperClass, props.sizeClass]"
        style="flex: 1 0 100%"
    >
        <span
            v-for="(m, i) in props.modifiers"
            :key="m.id || i"
            :class="props.innerClass"
        >
            {{ m.quantity > 1 ? `${m.quantity}x` : '' }}
            {{ m.name }}{{ i !== props.modifiers.length - 1 ? ',' : '' }}
        </span>
    </span>
</template>

<script>
export default {
    name: 'BasketLineItemModifiers',
    functional: true,
    props: {
        modifiers: { type: Array, default: () => [] },
        wrapperClass: { type: String, default: 'text-gray-600' },
        innerClass: { type: String, default: 'text-secondary' },
        sizeClass: { type: String, default: 'text-sm' }
    }
};
</script>
